import React from 'react';

import { AspectRatio, Box, Button, Title } from '@mantine/core';
import { IconArrowRight, IconBook, IconMail } from '@tabler/icons-react';
import { OnboardingStepTemplate } from 'pages/Onboarding/OnboardingSteps/OnboardingStepTemplate';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { YOUTUBE_DEMO_VIDEO_ID } from 'shared/constants/general-constants';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { extractRedirectPathFromQueryParams } from 'shared/utils/navigation';

const LINKS = {
  EMAIL: 'mailto:Contact Droxy<contact@droxy.ai>',
  DOCUMENTATION: 'https://docs.droxy.ai'
};

interface FinishStepProps {
  submitOnboardingData: () => void;
}

export function FinishStep({ submitOnboardingData }: FinishStepProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <OnboardingStepTemplate
      title={{
        text: t('ONBOARDING.FINISH_STEP.TITLE')
      }}
      description={t('ONBOARDING.FINISH_STEP.DESCRIPTION')}
      additionalLinks={{
        title: '',
        links: [
          {
            title: t('ONBOARDING.FINISH_STEP.ADDITIONAL_LINKS.EMAIL'),
            href: LINKS.EMAIL,
            icon: <IconMail />
          },
          {
            title: t('ONBOARDING.FINISH_STEP.ADDITIONAL_LINKS.DOCUMENTATION'),
            href: LINKS.DOCUMENTATION,
            icon: <IconBook />
          }
        ]
      }}
      additionalElement={
        <Box>
          <Button
            onClick={() => {
              submitOnboardingData();
              navigate(
                extractRedirectPathFromQueryParams(queryString.parse(location.search)) || ROUTE_LINKS.smartAssistants
              );
            }}
            rightIcon={<IconArrowRight />}>
            {t('APP.ACTIONS.GET_STARTED')}
          </Button>
        </Box>
      }
      rightElement={
        <Box w="100%" h="100%">
          <Title order={4}>{t('ONBOARDING.FINISH_STEP.VIDEO.TITLE')}</Title>
          <AspectRatio mt="sm" ratio={16 / 9}>
            <iframe
              style={{ border: 'none', borderRadius: 16 }}
              src={`https://www.youtube.com/embed/${YOUTUBE_DEMO_VIDEO_ID}`}
              title="Droxy Demo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </AspectRatio>
        </Box>
      }
    />
  );
}
